import React, { useEffect, useRef } from 'react';
import { Phone, MapPin, Mail, Clock, ChevronRight, Award, Star, Sparkles, IceCream, ShoppingBag } from 'lucide-react';
import '../styles/LandingPage.css';

// 🖼️ KÉPEK

import fagylaltHero from '../assets/fagylalt1.webp';      // főkép: bogyós-morzsás tölcsér (sötét háttér, Fazekas logó)
import fagylalt2 from '../assets/fagylalt2.webp';         // mangós-krémes tölcsér

import tulaj from '../assets/fagylalt3.webp';     // a cukrászda tulajdonosa fagylalttal
import sutemenyek from '../assets/sutemenyek.webp';       // sütemény fotó (ha van, különben cseréld le)
import sutemenyek2 from '../assets/sutemenyek2.jpg';     // másik sütemény fotó (ha van, különben cseréld le)
const LandingPage = ({ setCurrentPage }) => {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
          }
        });
      },
      { threshold: 0.1 }
    );

    const elements = document.querySelectorAll('.reveal');
    elements.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  return (
    <div className="landing-page">

      {/* ── HERO ─────────────────────────────────────────────── */}
      <section className="hero">
        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="hero-badge">Frissen Nyitva 2025-ben</div>
          <h1 className="hero-title">
            KisManó
            <span className="highlight">Cukrászda & Fagyizó</span>
          </h1>
          <p className="hero-subtitle">
            Gondosan válogatott sütemények és prémium fagylaltok egy helyen —<br />
            köztük <strong>Fazekas Ádám</strong> világbajnok fagylaltkészítő mester páratlan ízvilágú termékei.
          </p>
          <div className="hero-actions">
            <button className="cta-button" onClick={() => setCurrentPage('order')}>
              Kínálatunk & Rendelés <ChevronRight size={20} />
            </button>
            <button className="cta-button-outline" onClick={() => {
              document.getElementById('fazekas-section').scrollIntoView({ behavior: 'smooth' });
            }}>
              <Award size={18} strokeWidth={1.5} /> Világbajnok Fagyi
            </button>
          </div>
        </div>
        <div className="hero-decoration" />
      </section>

      {/* ── FEATURE KÁRTYÁK ─────────────────────────────────── */}
      <section className="features">
        <div className="feature-card reveal">
          <div className="feature-icon-wrap feature-icon-quality">
            <Sparkles size={28} strokeWidth={1.5} />
          </div>
          <h3>Prémium Minőség</h3>
          <p>Minőségre igényes készítőktől szerezzük be a legfinomabb édességeket</p>
        </div>
        <div className="feature-card reveal" style={{ animationDelay: '0.15s' }}>
          <div className="feature-icon-wrap feature-icon-champion">
            <Award size={28} strokeWidth={1.5} />
          </div>
          <h3>Világbajnok Fagyi</h3>
          <p>Fazekas Ádám, a magyar világbajnok fagylaltkészítő mester prémium kézműves fagylaltjai már nálunk is elérhetők</p>
        </div>
        <div className="feature-card reveal" style={{ animationDelay: '0.3s' }}>
          <div className="feature-icon-wrap feature-icon-order">
            <ShoppingBag size={28} strokeWidth={1.5} />
          </div>
          <h3>Rendelés & Elvitel</h3>
          <p>Szülinapra, névnapra vagy csak úgy — segítünk beszerezni a tökéletes desszertet</p>
        </div>
      </section>

      {/* ── FAZEKAS ÁDÁM SZEKCIÓ ────────────────────────────── */}
      <section className="fazekas-section" id="fazekas-section">
        <div className="fazekas-inner">
          {/* Bal: szöveg */}
          <div className="fazekas-text reveal">
            <div className="champion-badge">
              <Award size={18} />
              Fagylalt Világbajnok
            </div>
            <h2>Fazekas Ádám<br /><span>fagyijai nálunk</span></h2>
            <p>
              Büszkén kínáljuk <strong>Fazekas Ádám</strong> világbajnok fagylaltkészítő mester
              organikus ízvilágú készítményeit. Ádám fagylaltját 2024-ben világ legjobbjának ítélte a szakma, 
              így örömünkre szolgál, hogy Szegeden csak a Kismanó Cukiban kínálhatjuk a díjnyertest termékeit.
              
            </p>
            <p>
              Minden egyes gömb mögött szenvedély, precizitás és a legjobb
              alapanyagok állnak — pontosan az, amit egy világbajnoktól elvársz.
            </p>
            <div className="champion-stats">
              <div className="stat">
                <Star size={16} fill="currentColor" />
                <span>Világbajnoki cím</span>
              </div>
              <div className="stat">
                <Star size={16} fill="currentColor" />
                <span>Prémium alapanyagok</span>
              </div>
              <div className="stat">
                <Star size={16} fill="currentColor" />
                <span>Organikus ízek</span>
              </div>
            </div>
          </div>

          {/* Jobb: Pinterest-stílusú álló kártyák */}
          <div className="fazekas-gallery reveal">
            <div className="gallery-card">
              <img src={fagylaltHero} alt="Fazekas bogyós-morzsás prémium fagylalt" className="gallery-card-img" />
              <div className="gallery-overlay" />
              <div className="gallery-award-tag">
                <Award size={13} /> Világbajnok receptúra
              </div>
            </div>
            <div className="gallery-card">
              <img src={fagylalt2} alt="Mangós-krémes fagylalt" className="gallery-card-img" />
              <div className="gallery-overlay" />
            </div>
            
          </div>
        </div>
      </section>

      {/* ── RÓLUNK / SÜTEMÉNY ───────────────────────────────── */}
      <section className="specialty">
        <div className="specialty-content">
          <div className="specialty-text reveal">
            <span className="specialty-label">Rólunk</span>
            <h2>Minőség<br />és Odafigyelés</h2>
            <p>
              2025-ben nyitottam meg üzletemet azzal a céllal, hogy a legkiválóbb
              süteményeket és fagylaltokat hozzam el Szegedre. A kínálatot hatalmas
              odafigyeléssel és szigorú minőségi elvárásokkal válogatom össze a
              megbízható partnerektől. Hiszem, hogy a gondosan kiválasztott finomságok
              és a családias hangulat minden betérő vendég napját szebbé teszik.
            </p>
            <button className="secondary-button" onClick={() => setCurrentPage('order')}>
              Böngészés a Kínálatban
            </button>
          </div>
          <div className="specialty-image reveal">
            {/* 🖼️ Ha van jobb cukrászda/sütemény fotód, cseréld le: */}
            <img src={tulaj} alt="KisManó Cukrászda" className="specialty-photo" />
          </div>
        </div>
      </section>

      {/* ── SÜTEMÉNY HIGHLIGHT ──────────────────────────────── */}
      <section className="pastry-highlight">
       <div className="pastry-inner">
    {/* Itt a módosított rész: két kép egy közös tárolóban */}
    <div className="pastry-images-container reveal">
      <div className="pastry-image-wrapper">
        <img src={sutemenyek} alt="Prémium sütemények 1" className="pastry-photo" />
      </div>
      <div className="pastry-image-wrapper">
        <img src={sutemenyek2} alt="Prémium sütemények 2" className="pastry-photo torta-photo" />
      </div>
    </div>
          <div className="pastry-text reveal">
            <span className="specialty-label">Süteménykínálat</span>
            <h2>Friss Sütemények<br />Minden Napra</h2>
            <p>
              Gondosan válogatott süteményeink a Kiszombori Cukrászüzemből érkeznek.
              Legyen szó krémes tortáról, leveles tésztáról vagy háziasabb finomságokról —
              kínálatunk mindig friss és változatos.
            </p>
            <button className="secondary-button" onClick={() => setCurrentPage('order')}>
              Sütemények Megtekintése
            </button>
          </div>
        </div>
      </section>

      {/* ── KAPCSOLAT ───────────────────────────────────────── */}
      <section className="contact-info">
        <div className="info-grid">
          <div className="info-item">
            <MapPin className="info-icon" />
            <div>
              <h4>Cím</h4>
              <p>Kossuth Lajos sugárút 45<br />6724 Szeged</p>
            </div>
          </div>
          <div className="info-item">
            <Clock className="info-icon" />
            <div>
              <h4>Nyitvatartás</h4>
              <p>
                <strong>H–Cs:</strong> 7–10 & 12–18<br />
                <strong>Péntek:</strong> 7–10 & 12–19<br />
                <strong>Szo:</strong> 10–19 &nbsp;|&nbsp; <strong>V:</strong> 10–18
              </p>
            </div>
          </div>
          <div className="info-item">
            <Phone className="info-icon" />
            <div>
              <h4>Telefon</h4>
              <p>+36 20 231 9860</p>
            </div>
          </div>
          <div className="info-item">
            <Mail className="info-icon" />
            <div>
              <h4>Email</h4>
              <p>info@kismanocukiszeged.hu</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingPage;